export default {
      id: "icon-user-usage",
      viewBox: "0 0 17 17",
      url: "../icon/" + "icons.svg#icon-user-usage",
      toString: function () {
        return this.url;
      }
    }